import * as React from "react";
import { SVGProps } from "react";
function SvgArrowLeftIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.146 7.146a.5.5 0 0 1 0 .708l-3.97 3.97a.25.25 0 0 0 0 .353l3.97 3.97a.5.5 0 0 1 0 .707l-.792.792a.5.5 0 0 1-.708 0l-5.292-5.292a.5.5 0 0 1 0-.708l5.292-5.292a.5.5 0 0 1 .708 0l.792.792Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgArrowLeftIcon;
